import { render, staticRenderFns } from "./UserActivity.vue?vue&type=template&id=dc9df9ca"
import script from "./UserActivity.vue?vue&type=script&lang=js"
export * from "./UserActivity.vue?vue&type=script&lang=js"
import style0 from "./UserActivity.vue?vue&type=style&index=0&id=dc9df9ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports